export const formatDateForInput = (dateString) => {
  if (!dateString) return "";

  return new Date(dateString).toISOString().split("T")[0];
};
